// vue filters
import Vue from 'vue'
import utils from '../utils'

Vue.filter('empty', function (value) {
  return value === 0 ? value : value || '---'
})

Vue.filter('dateTime', function (value) {
  return utils.formatDateTime(value)
})
